import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Drawer, Flex, Select, Spin, Tabs } from "antd";
import InProgressOrder from "../components/MyOrders/InProgressOrder";
import ServiceRequest from "../components/MyOrders/ServiceRequest";
import PreviewRequestsPending from "../components/AllPreviewRequests/PreviewRequestsPending";
import ServiceRequestFinished from "../components/MyOrders/ServiceRequestFinished";
import PreviewRequestsInProgress from "../components/AllPreviewRequests/PreviewRequestsInProgress";
import { useDispatch } from "react-redux";
import { fetchPerviewsByStatus } from "../redux/previewsConstructionStatusSlice";
import EmptyOrder from "../components/MyOrders/EmptyOrder";
import { useTranslation } from "react-i18next";
import PreviewRequestFinished from "../components/AllPreviewRequests/PreviewRequestFinished";

const AllPreviewRequests = () => {

    const { t, i18n } = useTranslation();
    const { language } = i18n;

    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedStatusProg, setSelectedStatusProg] = useState("progress");
    const [selectedStatusFin, setSelectedStatusFin] = useState("finished");

    const [previews, setPreviews] = useState([]);
    const [previewsProg, setPreviewsProg] = useState([]);
    const [previewsFin, setPreviewsFin] = useState([]);

    const [loading, setLoading] = useState(false);


    const dispatch = useDispatch();

    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            try {
                const result = await dispatch(
                    fetchPerviewsByStatus(selectedStatus)
                ).unwrap();

                setPreviews(result || []);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchOrders();
    }, [selectedStatus, dispatch]);

    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            try {
                const result = await dispatch(
                    fetchPerviewsByStatus(selectedStatusProg)
                ).unwrap();

                setPreviewsProg(result || []);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchOrders();
    }, [selectedStatusProg, dispatch]);

    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            try {
                const result = await dispatch(
                    fetchPerviewsByStatus(selectedStatusFin)
                ).unwrap();

                setPreviewsFin(result || []);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchOrders();
    }, [selectedStatusFin, dispatch]);

    const onChange = (key) => {
        console.log(key);
    };


    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            try {

                const result = await dispatch(fetchPerviewsByStatus(selectedStatus)).unwrap();

                setPreviews(result || []);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchOrders();
    }, [selectedStatus, dispatch]);

    const items = [
        {
            key: "1",
            label: <span>{t("Pending")}</span>,
            children: <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4" dir={language == "en" ? "lrt" : "rtl"}>
                {previews?.length > 0 ? (
                    previews?.map((preview, index) => (
                        <PreviewRequestsPending
                            key={index}
                            id={preview.id}
                            isoDate={preview.updated_at}
                            dateV={preview.date}
                            timeV={preview.time}
                            addresss={preview.address}
                            area={preview.area}
                            statuss={preview.status}
                            description={preview.description}
                            levels_count={preview.levels_count}
                            units_count={preview.units_count}
                            construction_type={language == "en" ? preview.construction_type.name_en : preview.construction_type.name}
                            preprices={preview.preprices}
                            used_technologys={preview.preprices.map(preprice => preprice.company?.used_technologys || [])}
                        // adminData={preview.preprices[0]?.company?.admin || []}
                        />
                    ))
                ) : (
                    <p className="text-center text-2xl text-[#FE9B71] col-span-2 mt-7 pt-7">
                        {t("No preview requests")}
                    </p>
                )}

            </div>,
        },
        {
            key: "2",
            label: <span className="custom-tab-label">{t("In Progress")}</span>,
            children: <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4" dir={language == "en" ? "lrt" : "rtl"}>
                {previewsProg?.length > 0 ? (
                    previewsProg?.map((preview, index) => (
                        <PreviewRequestsInProgress
                            key={index}
                            id={preview.id}
                            isoDate={preview.updated_at}
                            addresss={preview.address}
                            area={preview.area}
                            statuss={preview.status}
                            description={preview.description}
                            levels_count={preview.levels_count}
                            units_count={preview.units_count}
                            construction_type={language == "en" ? preview.construction_type.name_en : preview.construction_type.name}
                            vdate={preview.date}
                            vtime={preview.time}
                            admin_id={preview.admin_id}
                            pre_cost_tax={preview.pre_cost_tax}
                            exp_cost_tax={preview.exp_cost_tax == null && 0}
                            reason={preview.reason == null && 0}
                            back_tax={preview.back_tax}
                            depositTax={preview.deposit_tax}
                            pre_cost_tax_old={preview.pre_cost_tax_old}
                        />
                    ))
                ) : (
                    <p className="text-center text-2xl text-[#FE9B71] col-span-2 mt-7 pt-7">
                        {t("No preview requests")}
                    </p>
                )}

            </div>,
        },
        {
            key: "3",
            label: <span>{t("Finished")}</span>,
            children: <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4" dir={language == "en" ? "lrt" : "rtl"}>
                {previewsFin?.length > 0 ? (
                    previewsFin?.map((preview, index) => (
                        <PreviewRequestFinished
                            key={index}
                            id={preview.id}
                            isoDate={preview.updated_at}
                            addresss={preview.address}
                            area={preview.area}
                            statuss={preview.status}
                            // statuss="final_report"
                            description={preview.description}
                            levels_count={preview.levels_count}
                            units_count={preview.units_count}
                            construction_type={language == "en" ? preview.construction_type.name_en : preview.construction_type.name}
                            rates_comment={preview.rate_comment}
                            rates={preview.rate}
                            attach_file={preview.attach_file}
                        />
                    ))
                ) : (
                    <p className="text-center text-2xl text-[#FE9B71] col-span-2 mt-7 pt-7">
                        {t("No preview requests")}
                    </p>
                )}

            </div>,
        },
    ];

    return (
        <div className="loadingTab all_orders">
            <div className="bg-[#FCFBFA] px-20 max-lg:px-5 py-8">
                <Link to="/" className='flex items-center text-[#283D63] font-semibold'>
                    {
                        language == "en" ? <>
                            <LeftOutlined />
                            <p className='ml-3'>{t("Back to home")}</p>
                        </> : <>
                            <RightOutlined />
                            <p className='mr-3'>{t("Back to home")}</p>
                        </>
                    }
                </Link>

                <div className="mt-8">
                    <div className="flex items-center">
                        <h2 className="text-[#14294F] font-semibold text-2xl">{t("All Preview Requests")}</h2>
                    </div>
                </div>

            </div>

            {loading ? (
                <Flex align="center" gap="middle">
                    <Spin size="large" className="mx-auto my-10" style={{ color: '#fe9b71' }} />
                </Flex>
            ) : previews?.length === 0 && previewsProg?.length === 0 && previewsFin?.length === 0 ? (
                <EmptyOrder />
            ) : (
                <div className={`loadingTab ${
                    language == "ar" && "loadingTab_ar"
                  } px-20 max-lg:px-5 chat-box py-5 pb-20`}>
                    <Tabs defaultActiveKey="1" items={items} onChange={onChange}
                        tabBarStyle={{
                            textAlign: language === "en" ? "left" : "right",
                        }} />
                </div>
            )}
        </div>
    );
};

export default AllPreviewRequests;
